// Navbar section component
import * as $ from "jquery";
import HeaderlessNavbar from "../../common/headerless-navbar";
import onThrottled from "../../utils/event";
import imkt from '../../imkt';
import "waypoints/lib/jquery.waypoints.js";

export default class Navbar {
  constants = {
    CHARLIE_LOGO_WIDTH: 36,
    NAVBAR_COLLAPSED_CLASS: "imkt-navbar__collapsed",
    NAVBAR_COLLAPSED_OPEN_CLASS: "imkt-navbar__collapsed--open",
    HEADERLESS_NAV: "headerless-nav",
  };
  domRoot: JQuery<any>;
  params: any;
  $navbar: any;
  $navbarMainSection: JQuery<HTMLElement>;
  $titleWrapper: JQuery<HTMLElement>;
  $charlieLogo: JQuery<HTMLElement>;
  $linkList: JQuery<HTMLElement>;
  $titleLink: JQuery<HTMLElement>;
  $navbarToggle: JQuery<HTMLElement>;
  $navbarButton: JQuery<HTMLElement>;
  $topLinks: JQuery<HTMLElement>;
  $dropdownLinksWrapper: any;
  $dropdownToggle: any;
  $desktopDropdownToggle: any;
  $collapsedSection: JQuery<HTMLElement>;
  $navbarHashLink: JQuery<HTMLElement>;
  $navSections: JQuery<HTMLElement>;
  navContentsWidth: number;
  $hoverableLinks: JQuery<HTMLElement>;
  $navbarHoverContent: JQuery<HTMLElement>;

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = $(domRoot);
    this.params = { ...params };
    this.$navbar = this.domRoot;
    this.$navbarMainSection = $(".imkt-navbar__main-section", this.$navbar);
    this.$titleWrapper = $(
      ".imkt-navbar__title-wrapper",
      this.$navbarMainSection
    );
    this.$charlieLogo = $(".imkt-navbar__charlie-logo-link", this.$titleWrapper);
    this.$linkList = $(".imkt-navbar__link-list", this.$navbarMainSection);
    this.$titleLink = $(".imkt-navbar__title-link", this.$titleWrapper);
    this.$navbarToggle = $("#jsToggleNavbarMenu", this.$titleWrapper);
    this.$navbarButton = $(".button", this.$navbarMainSection);
    this.$topLinks = $(".imkt-navbar__link-list-link", this.$navbarMainSection);
    // dropdown links elements
    this.$dropdownLinksWrapper = this.domRoot.find(
      ".imkt-navbar__collapsed-dropdown-links"
    );
    this.$dropdownToggle = this.domRoot.find(
      ".imkt-navbar__collapsed-link-list-link--dropdown-trigger"
    );
    this.$desktopDropdownToggle = this.domRoot.find(
      ".imkt-navbar__link-list-link--dropdown-trigger"
    );
    // collapsed elements
    this.$collapsedSection = $(".imkt-navbar__collapsed-section", this.$navbar);
    // hash links sections
    this.$navbarHashLink = $(".imkt-navbar__hash-link-nav", this.$domRoot);
    this.$navSections = $(".hash-link-section", this.$domRoot);
    // make width value of nav contents available to all functions
    this.navContentsWidth = 0;

    this.$hoverableLinks = $(".hoverable-link", this.$navbarMainSection);
    this.$navbarHoverContent = $(
      ".navbar-hover-content",
      this.$navbarMainSection
    );

    // only initialize javascript for default size navbar
    if (this.$navbar.hasClass("imkt-navbar__default") && this.$linkList.length) {
      this.init();
    } else {
      $("body").removeClass("headerless-nav");
    }
  }

  init() {
    var self = this;

    var headerlessNavbar = new HeaderlessNavbar(this.domRoot);
    try {
      if (headerlessNavbar.shouldUseHeaderlessNav()) {
        headerlessNavbar.initHeaderlessNav();
      } else {
        headerlessNavbar.disableHeaderlessNav();
      }
    } catch (e) {
      headerlessNavbar.disableHeaderlessNav();
    }

    // Allow fonts to render before working with element sizing
    $(document).on("font-face-applied", function () {
      if (self.params.hasCharlie == "true" && self.$charlieLogo.length) {
        self.setLogoTitleWidth();
      }

      self.getNavContentsWidth();
    });
    this.navSelection();
    self.setNavbarDisplayMode();
    this.$navbarHoverContent.hide();
    this.bindEvents();
    this.setDefaultHoverLinkContent();
  }

  bindEvents() {
    var self = this;

    onThrottled($(window), "resize", function () {
      self.setNavbarDisplayMode();
    });

    $(window).on("keyup", function () {
      if (
        document.activeElement.classList.contains("imkt-navbar__link-list-link")
      ) {
        self.$topLinks.each(function () {
          $(this).removeClass("active");
        });
        document.activeElement.classList.add("active");
      } else if (
        document.activeElement.classList.contains(
          "imkt-navbar__dropdown-links__link"
        )
      ) {
        /* keep parent element active to allow tab movement */
      } else {
        self.$topLinks.each(function () {
          $(this).removeClass("active");
        });
      }
    });
    // element will not be visible unless the navbar is in collapsed mode
    this.$navbarToggle.on("click", function () {
      self.toggleCollapsedNavbar();
    });

    this.$dropdownToggle.on("click", function (e) {
      e.preventDefault();
      var $this = $(this);
      $this.parent().find(
        ".imkt-navbar__collapsed-dropdown-links.dropdown-container"
      ).toggle();
      $this.toggleClass("open");
      return false;
    });

    this.$desktopDropdownToggle.on("click", function (e) {
      e.preventDefault();
    });

    $(document).on("click", function (e) {
      if (!$(e.target).hasClass("imkt-navbar__link-list-link")) {
        self.$topLinks.each(function () {
          $(this).removeClass("active");
        });
      }
    });

    this.$hoverableLinks.hover(function () {
      const hoverOverId = $(this).data("hover-content-id");
      if (hoverOverId) {
        // removed existing hovered tag
        self.$hoverableLinks.removeClass("hover-over");
        // hide current nav bar hover content
        self.$navbarHoverContent.hide();
        // set hover-over class on hovered link
        $(this).addClass("hover-over");
        // show hovered over content
        document.querySelector(`#${hoverOverId}`).style.display = "block";
      }
    });
  }

  isMobile() {
    return $(window).width() <= imkt.wpl.globals.mediaQueries.md.maxWidth;
  }

  navbarOpen() {
    return this.$navbar.hasClass(this.constants.NAVBAR_COLLAPSED_OPEN_CLASS);
  }

  toggleCollapsedNavbar() {
    this.$navbar.toggleClass(this.constants.NAVBAR_COLLAPSED_OPEN_CLASS);
    this.$collapsedSection.slideToggle();
  }

  getNavContentsWidth() {
    var self = this;

    this.navContentsWidth = 50; // initialize with a buffer

    this.navContentsWidth += this.$titleWrapper.width();

    $.each(this.$linkList.children("li"), function () {
      var $this = $(this);
      self.navContentsWidth += $this.outerWidth(true);
    });

    if (this.$navbarButton.length) {
      this.navContentsWidth += this.$navbarButton.width();
    }

    if (this.$navbarToggle.length) {
      this.navContentsWidth += this.$navbarToggle.outerWidth(true);
    }
  }

  setLogoTitleWidth() {
    // Create clones of our navbar title and get width of 'stuck' state
    var $titleClone = this.$titleLink.clone().find("span").css({
      fontSize: "1.5rem",
      opacity: 0,
      position: "absolute",
      visibility: "hidden",
    });

    var $titleCloneCollapsed = this.$titleLink.clone().find("span").css({
      fontSize: "1.125rem",
      opacity: 0,
      position: "absolute",
      visibility: "hidden",
    });

    this.$titleWrapper.after($titleClone, $titleCloneCollapsed); // add to page so we can get accurate width
    var initialTitleWidth = $titleClone[0].getBoundingClientRect().width; // store width
    $titleClone.remove(); // remove from page
    var stuckTitleWidth =
      $titleCloneCollapsed[0].getBoundingClientRect().width +
      this.constants.CHARLIE_LOGO_WIDTH; //store width
    $titleCloneCollapsed.remove(); // remove from page

    // assign optimal title wrapper width
    if (initialTitleWidth >= stuckTitleWidth) {
      this.$titleWrapper.width(initialTitleWidth);
    } else {
      this.$titleWrapper.width(stuckTitleWidth);
    }
  }

  setNavbarDisplayMode() {
    // if mobile, always set display mode to collapsed
    if (this.isMobile()) {
      this.$navbar.addClass(this.constants.NAVBAR_COLLAPSED_CLASS);
    } else {
      var navWidth = this.$navbarMainSection.find(".column").width();
      if (navWidth < this.navContentsWidth) {
        this.$navbar.addClass(this.constants.NAVBAR_COLLAPSED_CLASS);
      } else {
        this.$navbar.removeClass(this.constants.NAVBAR_COLLAPSED_CLASS);
        if (this.$navbar.hasClass(this.constants.NAVBAR_COLLAPSED_OPEN_CLASS)) {
          this.toggleCollapsedNavbar();
        }
      }
    }
  }

  navSelection() {
    var self = this;
    self.getNavContentsWidth();
    self.$navbarHashLink
      .find(".column")
      .width(self.navContentsWidth + 2)
      .fadeTo("300", 1)
      .find(self.$titleLink)
      .on("click", function (e) {
        e.preventDefault();
      });
    $.each(self.$navSections, function (index, section) {
      new Waypoint({
        element: $(section),
        handler(direction) {
          var id = $(this.element).attr("id");
          if (direction === "down") {
            self.updateActiveNavItem(id);
          } else {
            if (index == 0) {
              self.removeActiveNavItem(id);
            } else if (index !== 0) {
              id = $(self.$navSections[index - 1]).attr("id");
              self.updateActiveNavItem(id);
            }
          }
        },
        //,offset: '25%'
      });
    });
  }

  updateActiveNavItem(id) {
    this.removeActiveNavItem(id);
    this.$linkList.find('a[href="#' + id + '"]').addClass("active");
  }

  removeActiveNavItem() {
    this.$linkList.find("a").removeClass("active");
  }

  setDefaultHoverLinkContent() {
    if (this.$hoverableLinks.length > 0) {
      const setHoveredLink = this.$hoverableLinks.filter(".hover-over");
      // This assumes at init there would only be one default selected hover-over class
      if (setHoveredLink.length > 0) {
        const hoverOverId = setHoveredLink.data("hover-content-id");
        document.querySelector(`#${hoverOverId}`).style.display = "block";
      }
    }
  }
}
